<template>
    <div class="schedulesmslogVue" v-loading="loading">
        <div v-if="isEmployeeAllowed">
            <div class="o-main-content-area">
                <div class="o-page-top-heading c-responsive-fixwidth">
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-9">
                            <p class="u-back"><a href="javascript: void(0)" @click="backToSchedule()"><i class="fa fa-chevron-left"></i> Back</a></p>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group stylish-input-group" style="visibility:hidden;">
                                <input type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                    <button type="submit">
                                        <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-12">
                            <h1 class="h1" style="display: inline;">Notify Log:</h1>
                            <div style="display: inline; float: right;">
                                <a href="javascript: void(0)" @click="csvDownload()" class="c-common-btn c-common-btn--small"><i class="fa fa-download" aria-hidden="true"></i> Download CSV</a>
                            </div>
                            <h3 class="h3" v-if="getActionType == 'employeeAction'">{{employeeName}}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="o-ndividualArea c-responsive-fixwidth">
                <div v-loading="loading" 
                    class="o-ndividualTable" 
                    infinite-scroll-disabled="busy" 
                    infinite-scroll-distance="10"
                    v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                    ref="scrollContainer"
                    style="min-height: 1px;"
                >
                    <div v-for="(sms,index) in smsLogList" class="o-custom-table-container c-common-box-shadow c-radius3 sms-list-table-align o-overflow-visible" :key="index">
                        <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                            <div class="calls-table-row phonesheet-table-row">
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Message ID:</span>
                                                <div>{{sms.message_id}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Timestamp:</span>
                                                <div>{{getGlobalDateTimeFormat(sms.created_at)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Initiator:</span>
                                                <div>{{ (sms.user && sms.user.display_name) ? (sms.user.last_name + ", "+ sms.user.first_name) :''}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Sent To:</span>
                                                <div>{{(sms.notifiable && sms.notifiable.employable)?sms.notifiable.employable.last_name+", "+sms.notifiable.employable.first_name:''}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Type:</span>
                                            <div>{{sms.type}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Subject:</span>
                                            <div>{{sms.subject || ''}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Content:</span>
                                            <div>
                                                <a href="javascript: void(0)" class="o-tooltip-trigger">
                                                    {{(sms.body.length>50)?sms.body.substring(0, 49) + '...': sms.body}}
                                                    <div class="tooltip c-common-box-shadow">
                                                        {{sms.body}}
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Status:</span>
                                            <div>{{sms.status}}</div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>   
                    <div v-if="smsLogList.length <= 0 && apiData" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                    <div class="col-md-12 no-job-dispaly">
                        <i class="fa fa-frown-o" aria-hidden="true"></i>
                        <br />
                        No Data Stored
                    </div>
                    </div>           
                </div>          
            </div>
        </div>
        <div v-else>
            <NotAllowed />
        </div>
    </div>
</template>

<script>
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import NotAllowed from '@/components/NotAllowed';

    export default {
        components: {
            VueEditor,
            NotAllowed
        },
        data() {
            return {
                isEmployeeAllowed: true,
                loading:false,
                apiData:false,
                smsLogList: [],
                nextPageUrl: '',
                storeMore: [],
                employeeName:'',
                userDateFormat:null,
                userTimeFormat:null
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                loggedInEmployeeId: 'loggedInEmployeeId',
                getActionType: 'getNotificationType',
                job: 'getJob',
            })
        },
        methods: {
            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                let path = '';
                let header = {};
                if (this.getActionType == 'clientAction') {
                    path = 'job/'+atob(this.$route.params.empId)+'/notifyLogPhonesheet';
                    header = {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID,
                    };
                }else {
                    header = {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID,
                        'employeeId': atob(this.$route.params.empId)
                    };
                }
                if (this.storeMore.length != 0) {
                    var arr = this.smsLogList;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore = [];
                    if (this.nextPageUrl != null) {
                        await service.getUrl(this.nextPageUrl, header)
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.nextPageUrl = res.data.result.next_page_url;
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            backToSchedule() {
                this.$router.go(-1);

            },
            getTimeStamp(dateTime) {
                if (dateTime != 'undefined') {
                    return dateTimeConvert.utcTimeToUserTime(dateTime);
                }
            },

            getGlobalDateTimeFormat(data) {
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },
            async getEmpDetails() {
                this.$Progress.start();
                let reqID = '';
                if(this.getActionType == 'clientAction') {
                    reqID = this.loggedInEmployeeId;
                    console.log("Client:"+reqID);
                }else {
                   reqID = atob(this.$route.params.empId);
                    console.log("EMP"+reqID);

                }
                await service.get('employee/' + reqID, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    this.$Progress.finish();
                    this.employeeName=res.data.result.employable.first_name+" "+res.data.result.employable.last_name;
                    this.userDateFormat=res.data.result.date_format;
                    this.userTimeFormat=res.data.result.time_format;
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },
            csvDownload(){
                this.$Progress.start();
                let path = '';
                let header = {};
                if (this.getActionType == 'clientAction') {
                    path = 'job/'+atob(this.$route.params.empId)+'/notifyLogPhonesheetExport';
                    header = {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID,
                    };
                } else {
                    path = 'employee/notifyLogExport';
                    header = {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID,
                        'employeeId': atob(this.$route.params.empId),
                    };
                }
                service.get(path, header).then((res) => {
                    this.$Progress.finish();
                    this.JSONToCSVConvertor(res.data.result, "Notify Log", true);
                    
                }).catch((err) => {
                    console.log(err);
                });
            },
            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
                var CSV = '';
                CSV += ReportTitle + '\r\n\n';
                if (ShowLabel) {
                    var row = "";
                    for (var index in arrData[0]) {
                        row += index + ',';
                    }
                    row = row.slice(0, -1);
                    CSV += row + '\r\n';
                }

                for (var i = 0; i < arrData.length; i++) {
                    var row = "";
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }
                    row.slice(0, row.length - 1);
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }
                var fileName = "CS3_";
                fileName += ReportTitle.replace(/ /g, "_");
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
                var link = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        async created() {
            await this.getEmpDetails();
            // }
            let path = '';
            let header = {};
            if (this.getActionType == 'clientAction') {
                path = 'job/'+atob(this.$route.params.empId)+'/notifyLogPhonesheet';
                header = {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID,
                };
            } else {
                path = 'employee/notifyLog';
                header = {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID,
                    'employeeId': atob(this.$route.params.empId),
                };
            }
            this.loading=true;
            this.apiData=false;
            service.get(path, header).then((res) => {
                this.loading=false;
                this.apiData=true;
                this.smsLogList = res.data.result.data;
                this.nextPageUrl = res.data.result.next_page_url;
                if (this.nextPageUrl != null) {
                    this.$Progress.finish();
                    service.getUrl(this.nextPageUrl, header).then((res) => {
                        this.storeMore = res.data.result.data;
                        this.nextPageUrl = res.data.result.next_page_url;
                    }).catch((err) => {
                        console.log(err);
                    })
                }
                this.$Progress.finish();
            }).catch((err) => {
                console.log(err);
                this.loading=false;
                this.apiData=true;
                this.$Progress.finish();
            });
        }
    }

</script>
<style scoped>
        
    .sms-list-table-align .calls-table-row .calls-table-cell:first-child {
        width: 140px;
        text-align: center;
        padding-left: 10px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(2) {
        text-align: left;
        width: 180px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(3) {
        text-align: left;
        width: 200px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(4) {
        text-align: left;
        width: 200px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(5) {
        width: 75px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(6) {
        width: 350px;
    }
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(7) {
        width: 100px;
    } 
    .sms-list-table-align .calls-table-row .calls-table-cell:nth-child(8) {
        width: 70px;
    } 
    .check-disable i {
        opacity: 0.5;
    }
</style>
